import {useMediaQuery} from "@mui/material";

export function useWindowResizeToMobile() {
  const isMobile: boolean = useMediaQuery('(max-width:768px)');
  return isMobile;
}
